<template>
<v-container fluid>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <buscador-empleado v-if="idAccion != 2" :fn-seleccionar-empleado="fnSeleccionarEmpleado" :ban-limpiar-datos="banLimpiarDatos"></buscador-empleado>
        </v-col>
      </v-row>   
      <v-form 
        ref="form" 
        v-model="valid" 
        :lazy-validation="lazy"
      >
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="objResponsableSave.nue"
              :loading="loading"
              label="NUE"
              :rules="[(v) => !!v || 'Campo obligatorio']"
              :disabled="idAccion == 2"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="objResponsableSave.nombre"
              :loading="loading"
              label="Nombre"
              :rules="[(v) => !!v || 'Campo obligatorio']"
              :disabled="idAccion == 2"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="objResponsableSave.correo"
              :loading="loading"
              label="Correo electrónico"
              :rules="[(v) => !!v || 'Campo obligatorio']"
              :disabled="idAccion == 2"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
        </v-row>    
        <v-row>
          <v-col cols="12" md="6">
            <v-switch 
              v-model="objResponsableSave.esTitular" 
              class="mx-2" 
              label="Es titular" 
              required  
              style="justify-content: center; display: grid;  margin-top:5px;"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="12" md="6">
            <v-switch 
              v-model="objResponsableSave.habilitado" 
              class="mx-2" 
              label="Habilitado" 
              required  
              style="justify-content: center; display: grid;  margin-top:5px;"
              hide-details
            ></v-switch>
          </v-col>
        </v-row> 
      </v-form>   
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class="mx-2"
        color="default"
        v-if="idAccion==2"
        :loading="loadingSave"
        @click="inicializarFormularioDef"
      >
        cancelar
      </v-btn>
      <v-btn
        class="mx-2"
        color="success"
        :disabled="!valid"
        :loading="loadingSave"
        @click="guardarResponsable"
      >
      <v-icon class="mr-2">mdi-floppy</v-icon>
        guardar
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>

  </v-card>
  <v-snackbar
    key="snackbarFormServicioResponsable"
    v-model="snackbar"
    :bottom="true"
    :multi-line="true"
    :color="snackbarColor"
  >
    {{ snackbarTexto }}
    <v-btn dark text @click="snackbar = false;">
      Cerrar
    </v-btn>
  </v-snackbar> 
</v-container>
</template>

<script>
import { postResponsableServicio, putResponsableServicio } from "@/api";

export default {
  name: "FormServicioResponsable",
  components: {    
    BuscadorEmpleado: () => import("../comunes/BuscadorEmpleado"),
  },
  props: {
    objServicio: {
      type: Object,
      required: true
    },
    flagInit:{
      type: Number,
      default: 0
    },
    idAccion: {
      type: Number,
      default: 1
    },
    objResponsable: {
      type: Object,
      required: true
    },
    fnOnSave: {
      type: Function,
      default: () => {}
    },
    fnSetIdAccion: {
      type: Function,
      default: () => {}
    },
  },
  data () {
    return {
      loading: false,
      loadingSave: false,

      snackbar: false,
      snackbarColor: '',
      snackbarTexto: '',

      valid: false,
      lazy: false,

      objResponsableSave: {},
      banLimpiarDatos: 0,
    };
  },
  computed: {},
  watch: {
    flagInit: {
      handler (newValue, oldValue) {
        this.inicializarFormulario();
			},
    },
  },
  mounted () {
    this.inicializarFormulario();
  },
  methods: {
    inicializarFormulario(){
      var self = this;
      self.loading = true;
      
      if(this.$refs.form != undefined){
        this.$refs.form.resetValidation();
      }

      self.objResponsableSave = Object.assign({}, self.objResponsable);

      self.loading = false;
    },
    inicializarFormularioDef(){
      var self = this;
      self.loading = true;
      
      if(this.$refs.form != undefined){
        this.$refs.form.resetValidation();
      }

      self.objResponsableSave = { nue:'', nombre:'', correo:'', idCatServicio: self.objServicio.idCatServicio, esTitular: false, habilitado: false };

      self.loading = false;
      self.fnSetIdAccion(1);
      self.banLimpiarDatos++;
    },
    fnSeleccionarEmpleado(objEmpleado){
      if(objEmpleado == undefined){
        this.objResponsableSave.nue = '';
        this.objResponsableSave.nombre = '';
        this.objResponsableSave.correo = '';
      }
      else{
        this.objResponsableSave.nue = objEmpleado.nue;
        this.objResponsableSave.nombre = objEmpleado.nombre;
        this.objResponsableSave.correo = objEmpleado.correo;
      }
    },
    async guardarResponsable(){
      var self = this;

      if (self.$refs.form.validate()) {

        self.loadingSave = true;
        self.snackbar = false;
        self.snackbarTexto = "";
        self.snackbarColor = "";
            
        try {
          let response;

          if(self.objResponsableSave.idResponsableServicio == 0 || self.objResponsableSave.idResponsableServicio == undefined){
            response = await postResponsableServicio(self.objResponsableSave);
          }
          else{
            response = await putResponsableServicio(self.objResponsableSave);
          }

          if (response.status === 200) {
            if (response.data.flag === true) {
              if (response.data.message === "Guardado correcto" || response.data.message === "Actualizacion correcta") {
                self.snackbarTexto = "Responsable administrativo guardado con éxito";
                self.snackbarColor = "success";
                self.snackbar = true;

                self.fnOnSave();
                self.inicializarFormularioDef();
              }
            } else {
              self.snackbarTexto = "FormServicioResponsable: " + response.data.message;
              self.snackbarColor = "error";
              self.snackbar = true;
            }
          } else {
            self.snackbarTexto = "FormServicioResponsable: Error de red";
            self.snackbarColor = "error";
            self.snackbar = true;
          }
          self.loadingSave = false;
        } catch (e) {
          self.loadingSave = false;
          self.snackbarTexto = "FormServicioResponsable: " + e;
          self.snackbarColor = "error";
          self.snackbar = true;
        }
      }
    }
  }
};
</script>
